import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const IMG_1 =
  "https://images.pexels.com/photos/4173251/pexels-photo-4173251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_2 =
  "https://images.unsplash.com/photo-1758691461516-7e716e0ca135?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxkb2N0b3IlMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbCUyMGhvc3BpdGFsfGVufDB8fHx8MTc3ODQ3MDM5N3ww&ixlib=rb-4.1.0&q=85";

const testimonials = [
  {
    quote:
      "Marpay's psychiatric range is one of the few where the chemistry, the consistency and the patient outcomes actually line up. My SSRI prescriptions have moved almost entirely to Serolex.",
    name: "Dr. A. Krishnan",
    role: "Consultant Psychiatrist",
    city: "Bengaluru",
    image: IMG_2,
  },
  {
    quote:
      "Their orthopedic calcium and muscle-relaxant combinations are clean, predictable and priced fairly. That's a rare triangle in Indian pharma today.",
    name: "Dr. M. Iyer",
    role: "Orthopedic Surgeon",
    city: "Chennai",
    image: IMG_1,
  },
  {
    quote:
      "What surprised me was how responsive the Marpay medical team is — almost like talking to colleagues, not a sales channel.",
    name: "Dr. R. Mehta",
    role: "General Physician",
    city: "Pune",
    image: IMG_2,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[var(--mp-dark)] text-white py-24 md:py-32 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.15) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.15) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="overline mb-3" style={{ color: "var(--mp-gold)" }}>Voices from clinic</div>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter font-medium leading-[1.05]">
              What doctors say
              <br />
              when nobody's selling.
            </h2>
          </div>
          <p className="md:max-w-sm text-slate-300 leading-relaxed">
            We don't pay for these endorsements — and that's exactly the point. Unsolicited
            feedback from clinicians using our medicines daily.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i}`}
              className={`relative bg-white/[0.04] border border-white/10 rounded-3xl p-8 backdrop-blur-sm hover:bg-white/[0.07] transition-all duration-300 ${
                i === 1 ? "lg:translate-y-8" : ""
              }`}
            >
              <Quote className="h-7 w-7 mb-5" strokeWidth={1.5} style={{ color: "var(--mp-gold)" }} />
              <blockquote className="font-display text-lg leading-relaxed text-slate-100">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10 flex items-center gap-4">
                {/* <img
                  src={t.image}
                  alt={t.name}
                  className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20"
                  loading="lazy"
                /> */}
                <div>
                  <div className="font-medium text-white">{t.name}</div>
                  <div className="text-xs text-slate-400 mt-0.5">
                    {t.role} · {t.city}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
